import { BaseModalRef } from '@/app/helpers/types';
import { useOpen } from '@/app/hooks';
import { Box, Modal } from '@mui/material';
import { forwardRef, useImperativeHandle } from 'react';
import { UILoader } from '../ui/ui-loader';

const FullscreenLoader = forwardRef<BaseModalRef>((_props, ref) => {
  const { open, setOpen } = useOpen();

  useImperativeHandle(ref, () => ({
    open: onOpen,
    close: onClose,
  }));

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          position: 'fixed',
          zIndex: 9999,
          top: 0,
          left: 0,
          background: 'rgba(255, 255, 255, 0.5)',
          backdropFilter: 'blur(2px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <UILoader size={120} />
      </Box>
    </Modal>
  );
});

export default FullscreenLoader;
